/** @graphql cc **/

import gql from 'graphql-tag';

export const ContentOperationsQuery = gql`
	query ContentOperationsQuery($contentId: ID!, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
